// extracted by mini-css-extract-plugin
export default {"BottomNav":"BottomNav_BottomNav__PaxLx","BottomNavList":"BottomNav_BottomNavList__W2gjo"};